import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    "aria-label": "Chat on WhatsApp",
    href: _ctx.whatsAppLink,
    target: "_blank",
    rel: "noopener noreferrer",
    class: "whatsapp-icon"
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("img", {
      alt: "Chat on WhatsApp",
      src: "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
    }, null, -1)
  ]), 8, _hoisted_1))
}